module.exports = __webpack_public_path__ + "img/IC_Check_negro.52269ed5.svg";